var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-header',{attrs:{"value":_vm.value,"size":"h3","no-margins":_vm.noMargins,"uppercase":_vm.uppercase,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }